
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nos-partenaires/[slug]",
      function () {
        return require("private-next-pages/nos-partenaires/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nos-partenaires/[slug]"])
      });
    }
  